import * as yup from 'yup';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const timeTransform = function (value, originalValue) {
  if (!originalValue) return null;
  if (dayjs.isDayjs(originalValue))
    return originalValue.isValid() ? originalValue.toDate() : null;
  if (typeof originalValue === 'string') {
    const strict = dayjs(originalValue, 'HH:mm:ss', true);
    if (strict.isValid()) return strict.toDate();
    const generic = dayjs(originalValue);
    if (generic.isValid()) return generic.toDate();
    return null;
  }
  return value;
};

export const CreateConf = {
  schema: yup.object({
    yacht_contact: yup
      .string()
      .nullable()
      .required('Yacht contact is required'),
    location: yup.string().nullable().required('Location is required'),
    time_in: yup.date().nullable().transform(timeTransform),
    time_out: yup.date().nullable().transform(timeTransform),
    users_technicians: yup.string().nullable(),
    work_description: yup
      .string()
      .nullable()
      .required('Work description is required'),
    work_note: yup.string().nullable(),
    yacht_crew_signature: yup
      .mixed()
      .nullable()
      .required('Yacht signature is required'),
    na_tech_signature: yup
      .mixed()
      .nullable()
      .required('NA tech signature is required'),
  }),
  defaultValues: {
    work_date: dayjs().format('YYYY-MM-DD').toString(),
    yacht_contact: null,
    location: null,
    time_in: null,
    time_out: null,
    users_technicians: null,
    work_description: null,
    work_note: null,
    yacht_crew_signature: null,
    na_tech_signature: null,
  },
  fields: [
    {
      id: 'technical_divider',
      type: 'divider',
      label: 'Report',
      xs: 12,
    },

    {
      id: 'yacht_contact',
      name: 'yacht_contact',
      type: 'text',
      label: 'Yacht contact',
      required: true,
      xs: 12,
      sm: 6,
    },
    {
      id: 'users_technicians',
      name: 'users_technicians',
      type: 'text',
      label: 'User technicians',
      required: false,
      xs: 12,
      sm: 6,
    },
    {
      id: 'work_date',
      name: 'work_date',
      type: 'date',
      label: 'Work date',
      disabled: true,
      xs: 12,
      sm: 6,
    },
    {
      id: 'location',
      name: 'location',
      type: 'text',
      label: 'Location',
      required: true,
      xs: 12,
      sm: 6,
    },
    {
      id: 'time_in',
      name: 'time_in',
      type: 'time',
      label: 'Time in',
      required: false,
      xs: 12,
      sm: 6,
    },
    {
      id: 'time_out',
      name: 'time_out',
      type: 'time',
      label: 'Time out',
      required: false,
      xs: 12,
      sm: 6,
    },
    {
      id: 'work_description',
      name: 'work_description',
      type: 'text_multiline',
      label: 'Work description',
      required: true,
      xs: 12,
      minHeight: 100
    },
    {
      id: 'work_note',
      name: 'work_note',
      type: 'text_multiline',
      label: 'Work note',
      required: false,
      xs: 12,
      minHeight: 100
    },
    {
      id: 'signature_divider',
      type: 'divider',
      label: 'Signature',
      xs: 12,
    },
    {
      id: 'yacht_crew_signature',
      name: 'yacht_crew_signature',
      type: 'draw',
      title: 'Yacht crew signature ( please draw your signature here )*',
      required: true,
      xs: 6,
    },
    {
      id: 'na_tech_signature',
      name: 'na_tech_signature',
      type: 'draw',
      title: 'NA tech signature ( please draw your signature here )*',
      required: true,
      xs: 6,
    },
  ],
};
